export default "__VITE_ASSET__s4AQyS1j__"